import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { StepIds } from '../../../models/property-step/property-step-model';
import { PropertyInformationSectionComponent } from '../../../sections/lifestyle/property-information-section/property-information-section.component';
import { PropertyOpenHomeTimesSectionComponent } from '../../../sections/residential-for-sale/property-open-home-times-section/property-open-home-times-section.component';
import { PropertyFeaturesSectionComponent } from '../../../sections/lifestyle/property-features-section/property-features-section.component';
import { PropertyPageBase } from '../../property-page-base';
import { PropertySaleDetailsSectionComponent } from '../../../sections//residential-for-sale-agent/property-sale-details-section/property-sale-details-section.component';
import { PropertyParkingSectionComponent } from '../../../sections/residential-for-sale/property-parking-section/property-parking-section.component';
import { PropertyAgentContactDetailsSectionComponent } from '../../../sections/residential-for-sale-agent/property-agent-contact-details-section/property-agent-contact-details-section.component';
import { LifeStyleSubCategoryEnum } from '@classifieds-sell/datalayer';
import { DraftFacade, RouterFacade } from '@classifieds-sell/state';

@Component({
    templateUrl: './property-information-page.component.html',
    styleUrls: ['./property-information-page.component.scss'],
    host: { 'data-variant': 'lifestyle' },
    standalone: false
})
export class LifeStylePropertyInformationComponent
    extends PropertyPageBase
    implements AfterViewInit, OnInit, OnDestroy {
    @ViewChild(PropertyInformationSectionComponent, {
        read: PropertyInformationSectionComponent
    })
    propertyInformationSection: PropertyInformationSectionComponent;

    @ViewChild(PropertyFeaturesSectionComponent, {
        read: PropertyFeaturesSectionComponent
    })
    propertyFeaturesSectionComponent: PropertyFeaturesSectionComponent;

    @ViewChild(PropertyParkingSectionComponent, {
        read: PropertyParkingSectionComponent
    })
    propertyParkingSectionComponent: PropertyParkingSectionComponent;

    @ViewChild(PropertySaleDetailsSectionComponent, {
      read: PropertySaleDetailsSectionComponent
    })
    propertySaleDetailsSectionComponent: PropertySaleDetailsSectionComponent;

    @ViewChild(PropertyOpenHomeTimesSectionComponent, {
        read: PropertyOpenHomeTimesSectionComponent
    })
    propertyOpenHomeTimesSection: PropertyOpenHomeTimesSectionComponent;

    @ViewChild(PropertyAgentContactDetailsSectionComponent, {
      read: PropertyAgentContactDetailsSectionComponent
    })
    propertyAgentContactDetailsSection: PropertyAgentContactDetailsSectionComponent;
    constructor(
      draftFacade: DraftFacade,
      routerFacade: RouterFacade
    ) {
        super(StepIds.propertyInformation, draftFacade, routerFacade);
    }
    isDwellingSubcategory: boolean;

    ngOnInit(): void {
        super.onInit();
        this.isDwellingSubcategory = this.routerData.subCategory === LifeStyleSubCategoryEnum.dwelling;
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    ngAfterViewInit() {
        super.registerSection(this.propertyInformationSection);
        if(this.isDwellingSubcategory){
            super.registerSection(this.propertyFeaturesSectionComponent);
            super.registerSection(this.propertyParkingSectionComponent);
            super.registerSection(this.propertyOpenHomeTimesSection);
        }
        super.registerSection(this.propertySaleDetailsSectionComponent);
        super.registerSection(this.propertyAgentContactDetailsSection);
    }
}
